import { gql, useMutation } from '@apollo/client'
import { useNotification } from '@btime/react-messager'

import { cleanRequest } from './cleanRequest'
import { triggersClient } from '../../../../utils/apollo/api'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { useOpenTriggersModal } from '../../../../utils/routes/modals/modalsActions'
import { validate } from './validate'

const MUTATION = gql`
  mutation UpsertTrigger($input: TriggerInput) {
    upsertTrigger(input: $input) {
      id
    }
  }
`

export const useSaveTrigger = () => {
  const { entities } = useModalData()
  const openList = useOpenTriggersModal()
  const notify = useNotification()

  const [request, state] = useMutation(MUTATION, { refetchQueries: ['Triggers', 'Folders'], client: triggersClient })

  const handleRequest = (form, actions) => {
    const input = cleanRequest(form)
    const { setErrors } = actions
    const isValid = validate(form, setErrors)

    if (isValid) {
      return request({ variables: { input } }).then(resp => {
        if (!resp.errors) {
          openList({ entities, integrationsOnly: !!input.integrationId })
          notify.success({ title: 'Gatilho salvo com sucesso!!' })
        }
      })
    }
  }

  return [handleRequest, state]
}
